import { z } from 'zod';
import { NewsAndOffersType, NewsAndOffersStatus } from '@/features/news-and-offers/types/news-and-offers-dto';
import { t } from 'i18next';

export const NewsAndOffersPageFilterFormSchema = z.object({  
  types: z
    .array(z.nativeEnum(NewsAndOffersType))
    .optional(),
  statuses: z
    .array(z.nativeEnum(NewsAndOffersStatus))
    .optional(),
  startDate: z
    .date({ message: t('elements.form.startDate.error')})
    .nullable()
    .optional(),
  endDate: z
    .date()
    .nullable()
    .optional(),
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: t('elements.form.datesDifference.error'),
    path: ['endDate'],
  },
);